import useDynamicSelector from '../../hooks/useDynamicSelector';
import { TableColumnOptionsType, TableColumnSmxType } from '../../types';

const useProcessedColumns = <T extends string | TableColumnOptionsType | TableColumnSmxType>(
    columns: TableColumnSmxType[],
    type: 'hidden' | 'checkList' | 'options' | 'hiddenParent',
) => {
    const checkedList = useDynamicSelector('table', 'checkedList');

    const result: T[] = [];

    const processColumns = (columns: TableColumnSmxType[]) => {
        for (const column of columns) {
            if (column.children) {
                if (type === 'hiddenParent') {
                    column.hidden = column.children.length === column.children.filter((col) => col.hidden).length;
                } else {
                    processColumns(column.children);
                }
            } else {
                let object: T = '' as T;

                switch (type) {
                    case 'checkList':
                        object = column.dataIndex as T;
                        break;
                    case 'hidden':
                        column.hidden = !checkedList.includes(column.dataIndex);
                        object = column as T;
                        break;
                    case 'options':
                        object = {
                            key: column.key,
                            label: column.title!,
                            value: column.dataIndex,
                            typeField: column.typeDecode || column.type,
                        } as TableColumnOptionsType as T;
                        break;
                }
                result.push(object);
            }
        }
    };

    processColumns(columns);

    return result;
};

export default useProcessedColumns;
